import { createContext } from 'react';
import type { TTenantConfig } from '@glomopay/tenant';

type TTenantContextValue = {
  tenant: TTenantConfig;
  retry: () => void;
};

export const TenantContext = createContext<TTenantContextValue | null>(null);
